import { Api } from 'helpers/ApiClient';

export default async function getTrialLinkExpireDate(body){
  try {
    const response = await Api.client.post(
      '/api/v1/utils/check.json',
      body,
    );
    return response;
  } catch (e) {
    if (e.response && e.response.status !== 500) {
      return {
        status: e.response.status,
        error: e.response.data,
      };
    }
    return {
      error: 'Invalid access_token',
    };
  }
}


// WEBPACK FOOTER //
// ./src/scenes/SignUp/helpers/getTrialLinkExpireDate.js